import * as getPermissions from './reducers/get';
import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    PERMISSIONS_GET_REQUEST: getPermissions.request,
    PERMISSIONS_GET_FINISH: getPermissions.finish,
    PERMISSIONS_GET_ERROR: getPermissions.error,
});
